import React from "react";

export default function ShippingPolicy() {
  return (
    <div className="bg-white text-gray-800 px-6 md:px-16 lg:px-32 py-12">
      <h1 className="text-3xl md:text-4xl font-bold text-center mb-4">
        Shipping Policy
      </h1>
      <p className="text-center text-gray-500 mb-12 max-w-2xl mx-auto">
        Every VESHH-EON piece is crafted with intention — designed just for you. 
        Our shipping process reflects the same care and precision, ensuring your order 
        reaches you safely, wherever you are.
      </p>

      <div className="space-y-8">
        {/* Domestic Shipping */}
        <div>
          <h2 className="text-2xl font-semibold mb-3">Domestic Shipping</h2>
          <p className="text-gray-600 leading-relaxed">
            For our customers within India, orders are shipped through{" "}
            <span className="font-medium">registered domestic courier companies</span> 
            and/or Speed Post. 
            Orders are typically dispatched within{" "}
            <span className="font-medium">0–7 business days</span> from the date of 
            confirmation and payment. Delivery times may vary depending on your 
            location and courier norms, but we promise to hand over your order to the 
            courier partner with utmost care.
          </p>
        </div>

        {/* International Shipping */}
        <div>
          <h2 className="text-2xl font-semibold mb-3">International Shipping</h2>
          <p className="text-gray-600 leading-relaxed">
            For our global community, we ship exclusively through{" "}
            <span className="font-medium">registered international courier companies</span> 
            and/or International Speed Post. 
            Just like our clothing, each shipment is handled with precision and 
            responsibility, so you can be confident that your order is on its way — 
            no matter how far.
          </p>
        </div>

        {/* Delivery & Responsibility */}
        <div>
          <h2 className="text-2xl font-semibold mb-3">Delivery & Responsibility</h2>
          <p className="text-gray-600 leading-relaxed">
            Once your order is shipped, delivery timelines are subject to courier 
            company/postal service operations. While{" "}
            <span className="font-medium">VESHH-EON</span> guarantees dispatch within 
            the committed timeframe, we are not liable for delays caused by courier 
            or postal authorities. Delivery will always be made to the address you 
            provide during checkout.
          </p>
        </div>

        {/* Confirmation */}
        <div>
          <h2 className="text-2xl font-semibold mb-3">Order Confirmation</h2>
          <p className="text-gray-600 leading-relaxed">
            You’ll receive a confirmation on your registered email ID as soon as 
            your order is shipped. This is our way of assuring you that your 
            VESHH-EON piece — created just for you — is on its way. 
            For any queries, you may reach us at{" "}
            <span className="font-medium">support@veshheon.in</span> or 
            call us at <span className="font-medium">+91 9480743215</span>.
          </p>
        </div>
      </div>
    </div>
  );
}
